<!-- LABEL -->

<div
  class="text-sm pb-1 flex items-center"
  [class.font-bold]="bold"
>
  {{ label }}

  <div class="relative flex justify-center">

    @if (logo()) {

      <mat-icon
        class="h-4 w-4 text-base leading-4 ml-2 cursor-pointer"
        (mouseover)="showTooltip.set(true)"
        (mouseleave)="showTooltip.set(false)"
      >
        visibility
      </mat-icon>

      <mat-icon
        class="h-4 w-4 text-base text-red-500 leading-4 cursor-pointer"
        matTooltip="Remove logo"
        (click)="onRemoveLogoClick()"
      >
        delete
      </mat-icon>
    }

    @if (showTooltip()) {

      <div
        class="p-1 rounded shadow bg-white absolute h-auto w-40 left-8 top-[-2rem] max-h-40 z-10"
      >
        <img
          [src]="logo()"
          alt="Brand Logo"
        />
      </div>
    }

  </div>
</div>

<!-- NORMAL INPUT -->

@if (!isDatePicker && !isAutocomplete) {

  <mat-form-field
    appearance="outline"
    floatLabel="always"
    class="w-full input-control-field"
    [ngClass]="{ compact: true }"
  >

    @if (icon) {

      <mat-icon
        matPrefix
        class="h-5 w-5 text-xl leading-5 text-gray-500"
      >
        {{ icon }}
      </mat-icon>
    }

    <!-- NUMBER -->

    @if (type === 'number') {

      <!-- <input
        matInput
        positiveNumbersOnly
        [id]="id"
        [type]="type"
        [readonly]="readonly"
        [placeholder]="placeholder"
        [min]="numberMin"
        [max]="numberMax"
        [formControl]="ispFormControl"
        [ngClass]="class"
        (blur)="handleBlur()"
        (ngModelChange)="handleModelChange($event)"
      /> -->

            <input
        matInput
        positiveNumbersOnly
        [id]="id"
        [type]="type"
        [readonly]="readonly"
        [placeholder]="placeholder"
        [min]="numberMin"
        [max]="numberMax"
        [formControl]="ispFormControl"
        [ngClass]="class"
        (blur)="handleBlur()"
        (input)="handleModelChange(ispFormControl.value)"
      />
    }

    <!-- OTHER -->

    @if (type !== 'number') {

      <!-- <input
        matInput
        [id]="id"
        [type]="type"
        [readonly]="readonly"
        [placeholder]="placeholder"
        [minLength]="minlength"
        [maxLength]="maxlength"
        [formControl]="ispFormControl"
        [ngClass]="class"
        (blur)="handleBlur()"
        (ngModelChange)="handleModelChange($event)"
      /> -->

            <input
        matInput
        [id]="id"
        [type]="type"
        [readonly]="readonly"
        [placeholder]="placeholder"
        [minLength]="minlength"
        [maxLength]="maxlength"
        [formControl]="ispFormControl"
        [ngClass]="class"
        (blur)="handleBlur()"
        (input)="handleModelChange(ispFormControl.value)"
      />
    }

    <span
      matTextSuffix
      class="flex items-center gap-2"
    >

      @if (countChars && maxlength) {

        <span
          matTextSuffix
          class="text-gray-500"
        >
          {{ ispFormControl.value?.length || 0 }}/{{ maxlength }}
        </span>
      }

      @if (suffixIcon) {

        <span
          matTextSuffix
          class="text-gray-500 cursor-pointer"
          [matTooltip]="suffixIconTooltip"
          (click)="suffixClick($event)"
        >
          <mat-icon class="text-xl">
            {{ suffixIcon }}
          </mat-icon>
        </span>
      }

    </span>

    @if (hint) {

      <mat-hint class="text-xs">
        {{ hint }}
      </mat-hint>
    }

  </mat-form-field>
}

<!-- DATE PICKER -->

@if (isDatePicker) {

  <mat-form-field
    appearance="outline"
    floatLabel="always"
    class="w-full"
    [ngClass]="{ compact: true }"
  >

    @if (icon) {

      <mat-icon
        matPrefix
        class="h-5 w-5 text-xl leading-5 text-gray-500"
      >
        {{ icon }}
      </mat-icon>
    }

    <!-- <input
      matInput
      [id]="id"
      readonly
      [placeholder]="placeholder"
      [formControl]="ispFormControl"
      [matDatepicker]="datepicker"
      [min]="minDate"
      [max]="maxDate"
      (blur)="handleBlur()"
      (ngModelChange)="handleModelChange($event)"
    /> -->

        <input
      matInput
      [id]="id"
      readonly
      [placeholder]="placeholder"
      [formControl]="ispFormControl"
      [matDatepicker]="datepicker"
      [min]="minDate"
      [max]="maxDate"
      (blur)="handleBlur()"
      (input)="handleModelChange(ispFormControl.value)"
    />

    <mat-datepicker-toggle
      matIconSuffix
      [for]="datepicker"
    >
      <mat-icon matDatepickerToggleIcon>
        calendar_month
      </mat-icon>
    </mat-datepicker-toggle>

    <mat-datepicker #datepicker />

    @if (hint) {

      <mat-hint class="text-xs">
        {{ hint }}
      </mat-hint>
    }

  </mat-form-field>
}

<!-- AUTOCOMPLETE -->

@if (isAutocomplete) {

  <mat-form-field
    appearance="outline"
    floatLabel="always"
    class="w-full input-control-field compact"
  >

    @if (icon) {

      <mat-icon
        matPrefix
        class="h-5 w-5 text-xl leading-5 text-gray-500"
      >
        {{ icon }}
      </mat-icon>
    }

    <!-- <input
      matInput
      [id]="id"
      [type]="type"
      [readonly]="readonly"
      [placeholder]="placeholder"
      [minLength]="minlength"
      [maxLength]="maxlength"
      [formControl]="ispFormControl"
      [matAutocomplete]="customAutoComplete"
      [ngClass]="class"
      (blur)="handleBlur()"
      (ngModelChange)="handleModelChange($event)"
    /> -->
        <input
      matInput
      [id]="id"
      [type]="type"
      [readonly]="readonly"
      [placeholder]="placeholder"
      [minLength]="minlength"
      [maxLength]="maxlength"
      [formControl]="ispFormControl"
      [matAutocomplete]="customAutoComplete"
      [ngClass]="class"
      (blur)="handleBlur()"
      (input)="handleModelChange(ispFormControl.value)"
    />

    @if (countChars && maxlength) {

      <span
        matTextSuffix
        class="text-gray-500"
      >
        {{ ispFormControl.value?.length || 0 }}/{{ maxlength }}
      </span>
    }

    @if (suffixIcon) {

      <span
        matTextSuffix
        class="text-gray-500 cursor-pointer"
        (click)="suffixClick($event)"
      >
        <mat-icon>
          {{ suffixIcon }}
        </mat-icon>
      </span>
    }

    <mat-autocomplete
      #customAutoComplete="matAutocomplete"
    >

      @for (
        option of filteredAutocompleteOptions();
        track $index
      ) {

        <mat-option
          [value]="option[autocompleteOptionViewKey]"
        >
          {{ option[autocompleteOptionViewKey] }}
        </mat-option>
      }

    </mat-autocomplete>

    @if (hint) {

      <mat-hint class="text-xs">
        {{ hint }}
      </mat-hint>
    }

  </mat-form-field>
}

<!-- ERROR -->

@if (
  (ispFormControl.touched || ispFormControl.dirty) &&
  (
    (
      ispFormControl.errors &&
      ispFormControl.errors['required']
    ) ||
    ispFormControl.invalid
  )
) {

  <mat-error
    class="!text-sm"
    [ngClass]="specialCharacterValidationErrorClass"
  >
    @if (
      ispFormControl.errors && ispFormControl.errors['invalidInput']
    ) {

      <span>
        Only {{ allowedCharacters }} special characters are allowed.
      </span>

    } @else {

      <span>
        {{
          errorMessage === ''
            ? 'Field is required'
            : errorMessage
        }}
      </span>
    }

  </mat-error>
}